import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { ValuationReconciliation } from './valuationReconciliation';
import { CostApproach } from './costApproach';
import { ValuationApproachExclusionReason } from './valuationApproachExclusionReason';
import { Image } from './image';

export class AdditionalIdentifier {
	constructor(doc) {
		this.additionalValuationIdentifier = null;
		this.additionalValuationIdentifierType = null;

		this.additionalValuationIdentifier = x.getStringElement(doc, "./ns:AdditionalValuationIdentifier");
		this.additionalValuationIdentifierType = x.getStringElement(doc, "./ns:AdditionalValuationIdentifierType");
	}
}

export class IncomeApproachDetail {
	constructor(doc) {
		this.grossRentMultiplierFactorNumber = null;
		this.incomeAnalysisCommentDescription = null;
		this.valueIndicatedByIncomeApproachAmount = null;

		this.grossRentMultiplierFactorNumber = x.getNumericElement(doc, "./ns:GrossRentMultiplierFactorNumber");
		this.incomeAnalysisCommentDescription = x.getStringElement(doc, "./ns:IncomeAnalysisCommentDescription");
		this.valueIndicatedByIncomeApproachAmount = x.getMISMOAmountElement(doc, "./ns:ValueIndicatedByIncomeApproachAmount");
	}
}

export class IncomeApproach {
	constructor(doc) {
		this.incomeApproachDetail = null;
		this.valuationApproachExclusionReasons = [];
		var node;
		var nodes;

		node = x.selectSingleNode(doc, "./ns:INCOME_APPROACH_DETAIL");
		if (node !== null)
			this.incomeApproachDetail = new IncomeApproachDetail(node);
		nodes = x.selectNodes(doc, "./ns:VALUATION_APPROACH_EXCLUSION_REASONS/ns:VALUATION_APPROACH_EXCLUSION_REASON");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationApproachExclusionReasons.push(new ValuationApproachExclusionReason(xn));
			});
		}
	}

	GetExclusionReasons() {
		let reasons = '';

		if (!this.valuationApproachExclusionReasons) return reasons;

		for (const reason of this.valuationApproachExclusionReasons) {
			const r = reason.GetExclusionReasonType();
			reasons = h.addWithNewline(reasons, r);
		}

		return reasons;
	}

}

export class SalesComparisonApproachDetail {
	constructor(doc) {
		this.salesComparisonCommentDescription = null;
		this.valueIndicatedBySalesComparisonAmount = null;

		this.salesComparisonCommentDescription = x.getStringElement(doc, "./ns:SalesComparisonCommentDescription");
		this.valueIndicatedBySalesComparisonAmount = x.getMISMOAmountElement(doc, "./ns:ValueIndicatedBySalesComparisonAmount");
	}
}

export class SalesComparisonApproach {
	constructor(doc) {
		this.salesComparisonApproachDetail = null;
		this.valuationApproachExclusionReasons = [];
		var node;
		var nodes;

		node = x.selectSingleNode(doc, "./ns:SALES_COMPARISON_APPROACH_DETAIL");
		if (node !== null)
			this.salesComparisonApproachDetail = new SalesComparisonApproachDetail(node);
		nodes = x.selectNodes(doc, "./ns:VALUATION_APPROACH_EXCLUSION_REASONS/ns:VALUATION_APPROACH_EXCLUSION_REASON");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationApproachExclusionReasons.push(new ValuationApproachExclusionReason(xn));
			});
		}
	}
}

export class ApproachToValue {
	constructor(doc) {
		this.costApproach = null;
		this.incomeApproach = null;
		this.salesComparisonApproach = null;
		var node;

		node = x.selectSingleNode(doc, "./ns:COST_APPROACH");
		if (node !== null)
			this.costApproach = new CostApproach(node);
		node = x.selectSingleNode(doc, "./ns:INCOME_APPROACH");
		if (node !== null)
			this.incomeApproach = new IncomeApproach(node);
		node = x.selectSingleNode(doc, "./ns:SALES_COMPARISON_APPROACH");
		if (node !== null)
			this.salesComparisonApproach = new SalesComparisonApproach(node);
	}

	GetIncomeApproachIndicatedValue() {
			if (!this.incomeApproach) return "";
			if (!this.incomeApproach.incomeApproachDetail) return "";
			return this.incomeApproach.incomeApproachDetail.valueIndicatedByIncomeApproachAmount.ToDollarAmount() ?? "";
	}

	GetCostApproachIndicatedValue() {
			if (!this.costApproach) return "";
			if (!this.costApproach.costApproachDetail) return "";
			return this.costApproach.costApproachDetail.valueIndicatedByCostApproachAmount.ToDollarAmount() ?? "";
	}

	GetSalesComparisonApproachIndicatedValue() {
			if (!this.salesComparisonApproach) return "";
			if (!this.salesComparisonApproach.salesComparisonApproachDetail) return "";
			return this.salesComparisonApproach.salesComparisonApproachDetail.valueIndicatedBySalesComparisonAmount.ToDollarAmount() ?? "";
	}


}

export class ReconsiderationOfValue {
	constructor(doc) {
		this.reconsiderationOfValueCommentDescription = null;
		this.reconsiderationOfValueRequestedByType = null;
		this.reconsiderationOfValueResultDate = null;
		this.reconsiderationOfValueResultType = null;

		this.reconsiderationOfValueCommentDescription = x.getStringElement(doc, "./ns:ReconsiderationOfValueCommentDescription");
		this.reconsiderationOfValueRequestedByType = x.getStringElement(doc, "./ns:ReconsiderationOfValueRequestedByType");
		this.reconsiderationOfValueResultDate = x.getMISMODateElement(doc, "./ns:ReconsiderationOfValueResultDate");
		this.reconsiderationOfValueResultType = x.getStringElement(doc, "./ns:ReconsiderationOfValueResultType");
	}
}

export class ScopeOfWorkDetail {
	constructor(doc) {
		this.costApproachIndicator = null;
		this.governmentAgencyAppraisalIndicator = null;
		this.governmentAgencyAppraisalType = null;
		this.incomeApproachIndicator = null;
		this.propertyRightsNotAppraisedDescription = null;
		this.rentScheduleIndicator = null;
		this.salesComparisonApproachIndicator = null;
		this.siteValueIndicator = null;
		this.valuationAdditionalIntendedUserIndicator = null;
		this.valuationAdditionalScopeOfWorkIndicator = null;
		this.valuationAssignmentType = null;
		this.valuationAssignmentTypeOtherDescription = null;
		this.valuationScopeOfWorkDescription = null;

		this.costApproachIndicator = x.getBooleanElement(doc, "./ns:CostApproachIndicator");
		this.governmentAgencyAppraisalIndicator = x.getBooleanElement(doc, "./ns:GovernmentAgencyAppraisalIndicator");
		this.governmentAgencyAppraisalType = x.getStringElement(doc, "./ns:GovernmentAgencyAppraisalType");
		this.incomeApproachIndicator = x.getBooleanElement(doc, "./ns:IncomeApproachIndicator");
		this.propertyRightsNotAppraisedDescription = x.getStringElement(doc, "./ns:PropertyRightsNotAppraisedDescription");
		this.rentScheduleIndicator = x.getBooleanElement(doc, "./ns:RentScheduleIndicator");
		this.salesComparisonApproachIndicator = x.getBooleanElement(doc, "./ns:SalesComparisonApproachIndicator");
		this.siteValueIndicator = x.getBooleanElement(doc, "./ns:SiteValueIndicator");
		this.valuationAdditionalIntendedUserIndicator = x.getBooleanElement(doc, "./ns:ValuationAdditionalIntendedUserIndicator");
		this.valuationAdditionalScopeOfWorkIndicator = x.getBooleanElement(doc, "./ns:ValuationAdditionalScopeOfWorkIndicator");
		this.valuationAssignmentType = x.getStringElement(doc, "./ns:ValuationAssignmentType");
		this.valuationAssignmentTypeOtherDescription = x.getStringElement(doc, "./ns:ValuationAssignmentTypeOtherDescription");
		this.valuationScopeOfWorkDescription = x.getStringElement(doc, "./ns:ValuationScopeOfWorkDescription");
	}
}

export class ValuationIntendedUse {
	constructor(doc) {
		this.valuationIntendedUseDescription = null;

		this.valuationIntendedUseDescription = x.getStringElement(doc, "./ns:ValuationIntendedUseDescription");
	}
}

export class ValuationReportAdditionalCertification {
	constructor(doc) {
		this.valuationAdditionalCertificationIncludedByType = null;
		this.valuationAdditionalCertificationText = null;

		this.valuationAdditionalCertificationIncludedByType = x.getStringElement(doc, "./ns:ValuationAdditionalCertificationIncludedByType");
		this.valuationAdditionalCertificationText = x.getStringElement(doc, "./ns:ValuationAdditionalCertificationText");
	}
}

export class ValuationReportAdditionalIntendedUser {
	constructor(doc) {
		this.valuationAdditionalIntendedUserDescription = null;

		this.valuationAdditionalIntendedUserDescription = x.getStringElement(doc, "./ns:ValuationAdditionalIntendedUserDescription");
	}
}

export class ScopeOfWork {
	constructor(doc) {
		this.scopeOfWorkDetail = null;
		this.valuationIntendedUses = [];
		this.valuationReportAdditionalCertifications = [];
		this.valuationReportAdditionalIntendedUsers = [];
		var node;
		var nodes;

		node = x.selectSingleNode(doc, "./ns:SCOPE_OF_WORK_DETAIL");
		if (node !== null)
			this.scopeOfWorkDetail = new ScopeOfWorkDetail(node);
		nodes = x.selectNodes(doc, "./ns:VALUATION_INTENDED_USES/ns:VALUATION_INTENDED_USE");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationIntendedUses.push(new ValuationIntendedUse(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:VALUATION_REPORT_ADDITIONAL_CERTIFICATIONS/ns:VALUATION_REPORT_ADDITIONAL_CERTIFICATION");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationReportAdditionalCertifications.push(new ValuationReportAdditionalCertification(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:VALUATION_REPORT_ADDITIONAL_INTENDED_USERS/ns:VALUATION_REPORT_ADDITIONAL_INTENDED_USER");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationReportAdditionalIntendedUsers.push(new ValuationReportAdditionalIntendedUser(xn));
			});
		}
	}

	GetValuationIntendedUses() {
		const list = [];
		if (!this.valuationIntendedUses) return list;
		for (const u of this.valuationIntendedUses) {
			list.push(u.valuationIntendedUseDescription);
		}
		return list;
	}

	GetValuationIntendedUsers() {
		const list = [];
		if (this.valuationReportAdditionalIntendedUsers.length === 0)	return list;
		for (const u of this.valuationReportAdditionalIntendedUsers) {
			list.push(u.valuationAdditionalIntendedUserDescription);
		}
		return list;
	}

	GetAdditionalCertifications(type) {
		const list = [];
		if (this.valuationReportAdditionalCertifications.length === 0) return list;

		for (const c of this.valuationReportAdditionalCertifications) {
			if (c.valuationAdditionalCertificationIncludedByType === type) {
				list.push(c);
			}
		}
		return list;
	}

}

export class ValuationCommentary {
	constructor(doc) {
		this.valuationAnalysisCategoryType = null;
		this.valuationCommentText = null;
		this.valueMarketabilityImpactType = null;

		this.valuationAnalysisCategoryType = x.getStringElement(doc, "./ns:ValuationAnalysisCategoryType");
		this.valuationCommentText = x.getStringElement(doc, "./ns:ValuationCommentText");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
	}
}

export class OriginalValuationCondition {
	constructor(doc) {
		this.propertyValuationConditionalConclusionType = null;

		this.propertyValuationConditionalConclusionType = x.getStringElement(doc, "./ns:PropertyValuationConditionalConclusionType");
	}
}

export class SubjectToCompletionItemDetail {
	constructor(doc) {
		this.subjectToCompletionFeatureComparisonType = null;
		this.subjectToCompletionFeatureDescription = null;
		this.subjectToCompletionFeatureIncompleteOrInconsistentDescription = null;
		this.subjectToCompletionFeatureLocationDescription = null;

		this.subjectToCompletionFeatureComparisonType = x.getStringElement(doc, "./ns:SubjectToCompletionFeatureComparisonType");
		this.subjectToCompletionFeatureDescription = x.getStringElement(doc, "./ns:SubjectToCompletionFeatureDescription");
		this.subjectToCompletionFeatureIncompleteOrInconsistentDescription = x.getStringElement(doc, "./ns:SubjectToCompletionFeatureIncompleteOrInconsistentDescription");
		this.subjectToCompletionFeatureLocationDescription = x.getStringElement(doc, "./ns:SubjectToCompletionFeatureLocationDescription");
	}
}

export class SubjectToCompletionItem {
	constructor(doc) {
		this.images = [];
		this.subjectToCompletionItemDetail = null;
		var node;
		var nodes;

		nodes = x.selectNodes(doc, "./ns:IMAGES/ns:IMAGE");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.images.push(new Image(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:SUBJECT_TO_COMPLETION_ITEM_DETAIL");
		if (node !== null)
			this.subjectToCompletionItemDetail = new SubjectToCompletionItemDetail(node);
	}
}

export class SubjectToCompletionItems {
	constructor(doc) {
		this.subjectToCompletionItem = [];
		var nodes;

		nodes = x.selectNodes(doc, "./ns:SUBJECT_TO_COMPLETION_ITEM/ns:SUBJECT_TO_COMPLETION_ITEM");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.subjectToCompletionItem.push(new SubjectToCompletionItem(xn));
			});
		}
	}
}

export class ValuationCompletionDetail {
	constructor(doc) {
		this.appraisalCompletionCommentText = null;
		this.appraisalConditionsSatisfiedVerificationDescription = null;
		this.personalInspectionPerformedIndicator = null;
		this.propertyImprovementsCompletedIndicator = null;
		this.propertyImprovementsCompletedPerPlansIndicator = null;

		this.appraisalCompletionCommentText = x.getStringElement(doc, "./ns:AppraisalCompletionCommentText");
		this.appraisalConditionsSatisfiedVerificationDescription = x.getStringElement(doc, "./ns:AppraisalConditionsSatisfiedVerificationDescription");
		this.personalInspectionPerformedIndicator = x.getBooleanElement(doc, "./ns:PersonalInspectionPerformedIndicator");
		this.propertyImprovementsCompletedIndicator = x.getBooleanElement(doc, "./ns:PropertyImprovementsCompletedIndicator");
		this.propertyImprovementsCompletedPerPlansIndicator = x.getBooleanElement(doc, "./ns:PropertyImprovementsCompletedPerPlansIndicator");
	}
}

export class ValuationCompletion {
	constructor(doc) {
		this.originalValuationConditions = [];
		this.subjectToCompletionItems = [];
		this.valuationCompletionDetail = null;
		var node;
		var nodes;

		nodes = x.selectNodes(doc, "./ns:ORIGINAL_VALUATION_CONDITIONS/ns:ORIGINAL_VALUATION_CONDITION");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.originalValuationConditions.push(new OriginalValuationCondition(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:SUBJECT_TO_COMPLETION_ITEMS/ns:SUBJECT_TO_COMPLETION_ITEM");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.subjectToCompletionItems.push(new SubjectToCompletionItem(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:VALUATION_COMPLETION_DETAIL");
		if (node !== null)
			this.valuationCompletionDetail = new ValuationCompletionDetail(node);
	}
}

export class ValuationReportDetail {
	constructor(doc) {
		this.appraiserAdditionalCertificationIndicator = null;
		this.appraiserFileIdentifier = null;
		this.appraiserPriorServicesPerformedDescription = null;
		this.appraiserPriorServicesPerformedIndicator = null;
		this.appraiserSupervisorAdditionalCertificationIndicator = null;
		this.investorRequestedIdentificationCode = null;
		this.measurementStandardPublisherType = null;
		this.measurementStandardPublisherTypeOtherDescription = null;
		this.originalAppraisalEffectiveDate = null;
		this.originalAppraisalMarketingOrExposureDaysCount = null;
		this.originalAppraisalMarketingOrExposureHighRangeDaysCount = null;
		this.originalAppraisalMarketingOrExposureLowRangeDaysCount = null;
		this.originalAppraisedValueAmount = null;
		this.originalAppraiserFileIdentifier = null;
		this.originalAppraiserUnparsedName = null;
		this.originalLenderUnparsedName = null;
		this.propertyDataReportIndicator = null;
		this.reconsiderationOfValueIndicator = null;
		this.sketchExistsIndicator = null;
		this.valuationReportContentIdentifier = null;
		this.valuationReportInspectionCertificationType = null;

		this.appraiserAdditionalCertificationIndicator = x.getBooleanElement(doc, "./ns:AppraiserAdditionalCertificationIndicator");
		this.appraiserFileIdentifier = x.getStringElement(doc, "./ns:AppraiserFileIdentifier");
		this.appraiserPriorServicesPerformedDescription = x.getStringElement(doc, "./ns:AppraiserPriorServicesPerformedDescription");
		this.appraiserPriorServicesPerformedIndicator = x.getBooleanElement(doc, "./ns:AppraiserPriorServicesPerformedIndicator");
		this.appraiserSupervisorAdditionalCertificationIndicator = x.getBooleanElement(doc, "./ns:AppraiserSupervisorAdditionalCertificationIndicator");
		this.investorRequestedIdentificationCode = x.getStringElement(doc, "./ns:InvestorRequestedIdentificationCode");
		this.measurementStandardPublisherType = x.getStringElement(doc, "./ns:MeasurementStandardPublisherType");
		this.measurementStandardPublisherTypeOtherDescription = x.getStringElement(doc, "./ns:MeasurementStandardPublisherTypeOtherDescription");
		this.originalAppraisalEffectiveDate = x.getMISMODateElement(doc, "./ns:OriginalAppraisalEffectiveDate");
		this.originalAppraisalMarketingOrExposureDaysCount = x.getIntegerElement(doc, "./ns:OriginalAppraisalMarketingOrExposureDaysCount");
		this.originalAppraisalMarketingOrExposureHighRangeDaysCount = x.getIntegerElement(doc, "./ns:OriginalAppraisalMarketingOrExposureHighRangeDaysCount");
		this.originalAppraisalMarketingOrExposureLowRangeDaysCount = x.getIntegerElement(doc, "./ns:OriginalAppraisalMarketingOrExposureLowRangeDaysCount");
		this.originalAppraisedValueAmount = x.getMISMOAmountElement(doc, "./ns:OriginalAppraisedValueAmount");
		this.originalAppraiserFileIdentifier = x.getStringElement(doc, "./ns:OriginalAppraiserFileIdentifier");
		this.originalAppraiserUnparsedName = x.getStringElement(doc, "./ns:OriginalAppraiserUnparsedName");
		this.originalLenderUnparsedName = x.getStringElement(doc, "./ns:OriginalLenderUnparsedName");
		this.propertyDataReportIndicator = x.getBooleanElement(doc, "./ns:PropertyDataReportIndicator");
		this.reconsiderationOfValueIndicator = x.getBooleanElement(doc, "./ns:ReconsiderationOfValueIndicator");
		this.sketchExistsIndicator = x.getBooleanElement(doc, "./ns:SketchExistsIndicator");
		this.valuationReportContentIdentifier = x.getStringElement(doc, "./ns:ValuationReportContentIdentifier");
		this.valuationReportInspectionCertificationType = x.getStringElement(doc, "./ns:ValuationReportInspectionCertificationType");
	}
}

export class ValuationRevision {
	constructor(doc) {
		this.revisionCategoryType = null;
		this.revisionDate = null;
		this.revisionText = null;

		this.revisionCategoryType = x.getStringElement(doc, "./ns:RevisionCategoryType");
		this.revisionDate = x.getMISMODateElement(doc, "./ns:RevisionDate");
		this.revisionText = x.getStringElement(doc, "./ns:RevisionText");
	}
}

export class ValuationSoftwareSystem {
	constructor(doc) {
		this.valuationSoftwareProductIdentifier = null;
		this.valuationSoftwareProductName = null;
		this.valuationSoftwareProductVersionIdentifier = null;
		this.valuationSoftwareVendorName = null;

		this.valuationSoftwareProductIdentifier = x.getStringElement(doc, "./ns:ValuationSoftwareProductIdentifier");
		this.valuationSoftwareProductName = x.getStringElement(doc, "./ns:ValuationSoftwareProductName");
		this.valuationSoftwareProductVersionIdentifier = x.getStringElement(doc, "./ns:ValuationSoftwareProductVersionIdentifier");
		this.valuationSoftwareVendorName = x.getStringElement(doc, "./ns:ValuationSoftwareVendorName");
	}
}

export class ValuationUpdate {
	constructor(doc) {
		this.appraisalUpdateCommentDescription = null;
		this.appraisalUpdateReportEffectiveDate = null;
		this.propertyMarketValueDecreasedIndicator = null;

		this.appraisalUpdateCommentDescription = x.getStringElement(doc, "./ns:AppraisalUpdateCommentDescription");
		this.appraisalUpdateReportEffectiveDate = x.getMISMODateElement(doc, "./ns:AppraisalUpdateReportEffectiveDate");
		this.propertyMarketValueDecreasedIndicator = x.getBooleanElement(doc, "./ns:PropertyMarketValueDecreasedIndicator");
	}
}

export class ValuationReport {
	constructor(doc) {
		this.additionalIdentifiers = [];
		this.approachToValue = null;
		this.reconsiderationsOfValue = [];
		this.scopeOfWork = null;
		this.valuationCommentaries = [];
		this.valuationCompletion = null;
		this.valuationReconciliation = null;
		this.valuationReportDetail = null;
		this.valuationRevisions = [];
		this.valuationSoftwareSystems = [];
		this.valuationUpdate = null;
		var node;
		var nodes;

		nodes = x.selectNodes(doc, "./ns:ADDITIONAL_IDENTIFIERS/ns:ADDITIONAL_IDENTIFIER");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.additionalIdentifiers.push(new AdditionalIdentifier(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:APPROACH_TO_VALUE");
		if (node !== null)
			this.approachToValue = new ApproachToValue(node);
		nodes = x.selectNodes(doc, "./ns:RECONSIDERATIONS_OF_VALUE/ns:RECONSIDERATION_OF_VALUE");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.reconsiderationsOfValue.push(new ReconsiderationOfValue(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:SCOPE_OF_WORK");
		if (node !== null)
			this.scopeOfWork = new ScopeOfWork(node);
		nodes = x.selectNodes(doc, "./ns:VALUATION_COMMENTARIES/ns:VALUATION_COMMENTARY");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationCommentaries.push(new ValuationCommentary(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:VALUATION_COMPLETION");
		if (node !== null)
			this.valuationCompletion = new ValuationCompletion(node);
		node = x.selectSingleNode(doc, "./ns:VALUATION_RECONCILIATION");
		if (node !== null)
			this.valuationReconciliation = new ValuationReconciliation(node);
		node = x.selectSingleNode(doc, "./ns:VALUATION_REPORT_DETAIL");
		if (node !== null)
			this.valuationReportDetail = new ValuationReportDetail(node);
		nodes = x.selectNodes(doc, "./ns:VALUATION_REVISIONS/ns:VALUATION_REVISION");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationRevisions.push(new ValuationRevision(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:VALUATION_SOFTWARE_SYSTEMS/ns:VALUATION_SOFTWARE_SYSTEM");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationSoftwareSystems.push(new ValuationSoftwareSystem(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:VALUATION_UPDATE");
		if (node !== null)
			this.valuationUpdate = new ValuationUpdate(node);
	}

	GetAdditionalIdentifier(type) {
		if (!this.additionalIdentifiers)
			return "";
		for (const ai of this.additionalIdentifiers) {
			if (ai.additionalValuationIdentifierType === type) {
				return ai.additionalValuationIdentifier;
			}
		}
		return "";
	}

	GetValuationCommentaryText(type) {
		if (this.valuationCommentaries) {
			for (const commentary of this.valuationCommentaries) {
				if (commentary.valuationAnalysisCategoryType === type) {
					return commentary.valuationCommentText;
				}
			}
		}
		return "";
	}

	GetValuationCommentary(type) {
		if (this.valuationCommentaries) {
			for (const commentary of this.valuationCommentaries) {
				if (commentary.valuationAnalysisCategoryType === type) {
					return commentary;
				}
			}
		}
		return null;
	}

	RuleCommentaryHasCategoryType(type) {
		if (this.valuationCommentaries) {
			for (const commentary of this.valuationCommentaries) {
				if (commentary.valuationAnalysisCategoryType === type) {
					return true;
				}
			}
		}
		return false;
	}

	RuleHasDuplicateCommentaryCategories() {
		if (!this.valuationCommentaries)
			return false;

		const categories = new Set();
		for (const commentary of this.valuationCommentaries) {
			const cat = this.descriptionOrOther(
					commentary.valuationAnalysisCategoryType,
					commentary.valuationAnalysisCategoryTypeOtherDescription);

			if (!cat)
				continue; // Skip empty elements (kludge for bad XML)

			if (categories.has(cat))
				return true;
			categories.add(cat);
		}
		return false;
	}

	GetValuationImpact(type) {
		if (this.valuationCommentaries) {
			for (const commentary of this.valuationCommentaries) {
				if (commentary.valuationAnalysisCategoryType === type) {
					return commentary.valueMarketabilityImpactType;
				}
			}
		}
		return "";
	}

	GetMeasurementStandardType() {
		return h.descriptionOrOther(
			this.valuationReportDetail.measurementStandardPublisherType,
			this.valuationReportDetail.measurementStandardPublisherTypeOtherDescription);
	}

}
